/** Select value: real diary id, or `date:yyyy-MM-dd` for virtual Today/Tomorrow rows. */
export function dietDaySelectValue(day) {
	if (day && day.id != null && String(day.id) !== "") {
		return String(day.id);
	}
	return `date:${dietDayDateKey(day && day.date)}`;
}

/** Normalize API date to yyyy-MM-dd. */
export function dietDayDateKey(date) {
	if (!date) {
		return "";
	}
	if (/^\d{4}-\d{2}-\d{2}/.test(date)) {
		return String(date).slice(0, 10);
	}
	const parsed = new Date(date);
	if (!Number.isNaN(parsed.getTime())) {
		const y = parsed.getFullYear();
		const m = String(parsed.getMonth() + 1).padStart(2, "0");
		const d = String(parsed.getDate()).padStart(2, "0");
		return `${y}-${m}-${d}`;
	}
	return String(date);
}

export function findDietDayByDate(days, ymd) {
	const key = dietDayDateKey(ymd);
	if (!key || !Array.isArray(days)) {
		return undefined;
	}
	return (
		days.find(
			(day) =>
				dietDayDateKey(day.date) === key &&
				day.id != null &&
				String(day.id) !== ""
		) ?? days.find((day) => dietDayDateKey(day.date) === key)
	);
}

export function findDietDayBySelectValue(days, value) {
	if (!Array.isArray(days) || value == null || value === "") {
		return undefined;
	}
	const exact = days.find((day) => dietDaySelectValue(day) === String(value));
	if (exact) {
		return exact;
	}
	if (String(value).startsWith("date:")) {
		return findDietDayByDate(days, String(value).slice(5));
	}
	return undefined;
}

export function isVirtualDietDay(day) {
	return !day || day.id == null || String(day.id) === "";
}

/**
 * Keep the current picker value when it still exists.
 * Otherwise fall back to Today (virtual Today is fine).
 */
export function resolveDietDaySelection(days, currentSelectValue, todayYmd) {
	if (currentSelectValue) {
		const stillThere = findDietDayBySelectValue(days, currentSelectValue);
		if (stillThere) {
			return {day: stillThere, fellBackToToday: false};
		}
	}
	const today = findDietDayByDate(days, todayYmd) ?? (days && days[0]);
	return {day: today, fellBackToToday: true};
}

export function allowedFoodLabel(food) {
	if (!food) {
		return "";
	}
	return food.displayName || food.name || "";
}
